import React from "react";
import "./PhotographyPage.css";
import { Link } from "react-router-dom";
import { AboutIcon } from "../../images/icons/icons";
import data from "../../data.json";
import Fade from "react-reveal/Fade";

const PhotographyPage = () => {
	return (
		<section className="photography-page">
			<header className="photography-page__header">
				<h1 className="photography-page__heading photography-page__heading--main">
					Photography
				</h1>
				<p className="photography-page__subheading">
					Photography showcase of some of my work.
				</p>
			</header>
			<Fade bottom cascade>
				<div className="photography-page__body">
					{Object.keys(data.pictures).map((slug, i) => {
						const picture = data.pictures[slug];
						return (
							<p className="me" ><a href="https://verissimophotography.mypixieset.com/">CLICK</a></p>

						);
					})}
				</div>
			</Fade>
		</section>
	);
};

export default PhotographyPage;
